import { ClearSubmissionData, SalesDemoClient } from 'clients';
import { FileType, QueryKeys } from 'enums';
import { useClient } from 'hooks/useClient';
import { Submission } from 'types';
import { useQueryMutation } from './query/useMutate';
import { useImperativeQuery } from './query/useQuery';

export function useMutateSalesDemo() {
  const salesDemoClient = useClient(SalesDemoClient);

  const fetchFromAMS = useImperativeQuery<void | null, string>({
    queryFn: (submissionId) => salesDemoClient.fetchFromAMS(submissionId),
    queryKey: [QueryKeys.SalesDemo, 'fetch-from-ams'],
  });

  const marketViaAPI = useImperativeQuery<void | null, string>({
    queryFn: (submissionId) => salesDemoClient.marketViaAPI(submissionId),
    queryKey: [QueryKeys.SalesDemo, 'market-via-api'],
  });

  const marketViaEmail = useImperativeQuery<void | null, string>({
    queryFn: (submissionId) => salesDemoClient.marketViaEmail(submissionId),
    queryKey: [QueryKeys.SalesDemo, 'market-via-email'],
  });

  const marketViaPortal = useImperativeQuery<void | null, string>({
    queryFn: (submissionId) => salesDemoClient.marketViaPortal(submissionId),
    queryKey: [QueryKeys.SalesDemo, 'market-via-portal'],
  });

  const receiveQuotes = useImperativeQuery<
    void | null,
    { submissionId: string; quoteType?: FileType.MarketQuote | FileType.RenewalPolicy }
  >({
    queryFn: ({ submissionId, quoteType }) => salesDemoClient.receiveQuotes(submissionId, quoteType),
    queryKey: [QueryKeys.SalesDemo, 'receive-quotes'],
  });

  const createProposal = useImperativeQuery<void | null, string>({
    queryFn: (submissionId) => salesDemoClient.createProposal(submissionId),
    queryKey: [QueryKeys.SalesDemo, 'create-proposal'],
  });

  const writeToAMS = useImperativeQuery<void | null, string>({
    queryFn: (submissionId) => salesDemoClient.writeToAMS(submissionId),
    queryKey: [QueryKeys.SalesDemo, 'write-to-ams'],
  });

  const clearSubmission = useQueryMutation<Submission, ClearSubmissionData>(
    (data) => salesDemoClient.clearSubmission(data),
    QueryKeys.SalesDemo,
  );

  return {
    fetchFromAMS,
    marketViaAPI,
    marketViaEmail,
    marketViaPortal,
    receiveQuotes,
    createProposal,
    writeToAMS,
    clearSubmission,
  };
}
